<template>
  <div id="statement-list">
    <div class="row m-t-20" v-if="quotes">
      <div
        id="statement"
        class="quote-item-wrapper col-12 scroller"
        :style="{ 'max-height': max_height }"
        v-if="quotes.length > 0"
      >
        <div
          class="quote-item card card-default border p-l-15 p-r-15"
          style="border-radius: 10px"
          v-for="(q, index) in quotes"
          :key="index"
        >
          <div class="row post-content mt-2">
            <div class="col-md-12">
              <div class="d-flex align-items center">
                <div
                  class="account-name h6"
                  style="width: 75%"
                  v-html="q.speaker"
                ></div>
                <div
                  class="ml-auto fs-12 d-flex"
                  style="margin-top: 2px !important; width: 25%"
                >
                  <span class="ml-auto">
                    <i class="bi bi-calendar-event"></i>
                    {{ dateindo(q.date.$date) }}
                  </span>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <span class="m-r-10 post-number">
                  <i
                    class="bi"
                    :class="
                      q.source == 'news'
                        ? 'bi-globe-americas'
                        : q.source == 'media_cetak'
                        ? 'bi-newspaper'
                        : 'bi-tv'
                    "
                  ></i>
                  {{ q.account ? q.account : "Tidak Tercantum" }}
                </span>
                <div v-if="q.sentiment != null" class="m-r-10">
                  <span
                    class="badge rounded badge-success"
                    :class="
                      q.sentiment == 1
                        ? 'badge-success'
                        : q.sentiment == -1
                        ? 'badge-danger'
                        : 'bg-secondary'
                    "
                  >
                    {{
                      q.sentiment == 1
                        ? "Positif"
                        : q.sentiment == -1
                        ? "Negatif"
                        : "Netral"
                    }}
                  </span>
                </div>
              </div>
              <p class="post-text-content text-justify mt-2">
                <span
                  class="text-content"
                  v-html="writeContent(q.quote)"
                ></span>
                <a
                  href="javascript:void(0)"
                  v-if="cekString(q.quote)"
                  @click="showFullContent($event, index)"
                >
                  Selengkapnya</a
                >
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 d-flex mb-2">
              <span
                id="lihat-berita"
                class="ml-auto font-weight-bolder hoverable clickable text-success"
                @click="showDetailModal(q.id_stream.$oid)"
                ><i class="bi bi-eye" aria-hidden="true"></i> Lihat Berita</span
              >
              <span
                v-if="isAdmin && is_crud"
                id="edit-statement"
                class="ml-2 font-weight-bolder hoverable clickable"
                style="color: #14a1c8 !important"
                @click="editStatement(q)"
              >
                <i class="bi bi-pencil-square" aria-hidden="true"></i>
                Edit
              </span>
              <span
                v-if="isAdmin && is_crud"
                id="hapus-statement"
                class="ml-2 text-danger font-weight-bolder hoverable clickable"
                @click="deleteStatement(q._id.$oid)"
              >
                <i class="bi bi-trash" aria-hidden="true"></i>
                Hapus
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="col-md-12 col-sm-12 col-lg-12">
        <div
          class="alert alert-danger mt-3"
          id="errorApiEl"
          role="alert"
          align="center"
        >
          <strong>Mohon maaf, data tidak tersedia! </strong> <br />
          Silahkan lakukan pencarian dengan parameter lain
        </div>
      </div>
    </div>
    <modal-detail-post-component
      v-if="isShowModalDetail"
      :id_stream="id_stream"
      :key="detail_key"
      @close="closeModalDetail"
    />
    <modal-dynamic-component
      v-if="show_modal_dynamic"
      :key="modal_dynamic_key"
      modal_id="modal-edit-quotes"
      :modal="modal_dynamic"
      :data="statement_data"
      modal_size="modal-lg"
    />
  </div>
</template>

<script>
import $ from "jquery";
import gp from "@/plugins/generalPlugins.js";
import modal_detail_post from "@/views/components/mention/modal_detail_post.vue";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_edit_statement from "@/views/components/quotes-extraction/modal_edit_statement.vue";
import swal from "sweetalert";

export default {
  name: "statement_list",
  components: {
    "modal-detail-post-component": modal_detail_post,
    "modal-dynamic-component": modal_dynamic,
  },
  props: {
    quotes: {
      type: Array,
      default: () => {
        return [];
      },
    },
    max_height: {
      type: String,
      default: () => {
        return "21.6rem";
      },
    },
    is_crud: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
  },
  data() {
    return {
      search: "",
      stringLimit: 200,
      id_stream: null,
      detail_key: 300,
      modal_dynamic_key: 100,
      show_modal_dynamic: false,
      statement_data: null,
      isShowModalDetail: false,
    };
  },
  methods: {
    showDetailModal: function (id) {
      this.id_stream = id;
      this.detail_key++;
      this.isShowModalDetail = true;
    },
    closeModalDetail: function () {
      this.isShowModalDetail = false;
    },
    searchPost: function () {
      console.log("search");
    },
    dateindo: function (tanggal) {
      return gp.dateTimeID(tanggal);
    },
    showFullContent: function (event, index) {
      var contentEl = $(event.target).prev();
      var text = $(event.target).prev().text();
      text = text.replace(/\s{2,}/g, " ");
      if (text.length <= this.stringLimit) {
        text = this.markString(this.quotes[index].quote);
        $(event.target).html(" Sembunyikan");
      } else {
        text = this.markString(
          this.quotes[index].quote.substring(0, this.stringLimit)
        );
        $(event.target).html(" Selengkapnya");
      }
      contentEl.html(text);
    },
    cekString: function (text) {
      if (text.length > this.stringLimit) {
        return true;
      } else {
        return false;
      }
    },
    markString: function (content) {
      let kata = [];
      if ("quote" in this.$route.query) {
        kata = this.$route.query.quote;
        kata = gp.extractPhrase(kata);
      }
      kata = [...new Set(kata)];
      kata.forEach(function (word) {
        word = word.replaceAll('"', "");
        word = word.trim();
        let reg_exp = new RegExp("(\\b" + word + "\\b)", "gi");
        content = content.replace(
          reg_exp,
          ` <mark data-markjs="true"> ${word}  </mark> `
        );
      });
      return content;
    },
    writeContent: function (text) {
      var batasKata = this.stringLimit;
      var newText = text.substring(0, batasKata);
      if ("quote" in this.$route.query) {
        newText = this.markString(newText);
      }
      return newText;
    },
    imageUrlAlt: function () {
      event.target.src = "/assets/img/profiles/default.png";
    },
    deleteStatement: function (id) {
      let self = this;
      let params = {
        ids: [id],
      };
      event.preventDefault();
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus statement ini.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
        className: "swal-custom",
      }).then((yess) => {
        if (yess) {
          let api = process.env.VUE_APP_API_URL + "quotes-delete";
          this.$http
            .post(api, params)
            .then(function (response) {
              if (response.status == 200) {
                self.$parent.getData(true);
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Statement berhasil dihapus.',
                    position: "top",
                    timeout: 4000,
                    type: "success",
                  })
                  .show();
              } else {
                swal(
                  "Error!",
                  "Gagal menghapus data. Silahkan coba lagi.",
                  "warning"
                );
              }
            })
            .catch(function () {
              swal(
                "Error!",
                "Terjadi kesalahan saat menghapus data. Silahkan coba lagi.",
                "warning"
              );
            });
        }
      });
    },
    editStatement: function (data) {
      this.statement_data = data;
      this.modal_dynamic = {
        title: "Edit Statement",
        subtitle: "",
        component: modal_edit_statement,
      };
      if (!this.show_modal_dynamic) {
        this.show_modal_dynamic = true;
      } else {
        this.modal_dynamic_key++;
      }
    },
  },
  computed: {
    isAdmin: function () {
      let user_role = this.$store.getters.user.role;
      if (user_role == 2 || user_role == 3) {
        return true;
      }
      return false;
    },
  },
  created() {
    window.addEventListener("keydown", (e) => {
      if (e.key == "Escape") {
        this.isShowModalDetail = false;
      }
    });
  },
  mounted() {
    let self = this;
    $("#quote-post").on("#modal hidden.bs.modal", function () {
      self.isShowModalDetail = false;
    });
  },
};
</script>